import Icon from '../../components/Icon.vue'

Icon.register({"brands/facebook-messenger":{"width":448,"height":512,"paths":[{"d":"M224 32C15.9 32-77.5 278 84.6 400.6V480L160.3 438C302.5 477.8 445.7 378.1 445.7 239.3 445.8 124.8 346.5 32 224 32zM247.4 310.1L190 250.5 79.6 311.6 200.7 183.1 258.1 242.7 368.5 181.6 247.4 310.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/facebook-messenger.js
// module id = 5tZg
// module chunks = 0